import { Button } from 'react-bootstrap';
import LabelRequired from 'src/app/modules/component/LabelRequired';
import TextField from 'src/app/modules/component/TextField';

const XetNghiemCanLamSang = () => {
	return (
		<div className='spaces'>
			<div className="d-flex spaces pb-4">
				<LabelRequired label="3. Các xét nghiệm cận lâm sàng cần làm: " />
				<Button className="link-info bg-white text-decoration-underline spaces pb-0">
					Chọn dịch vụ
				</Button>
			</div>
			<TextField as="textarea" name="forms.paraclinicalTest" className="spaces pl-8" />
		</div>
	);
};

export default XetNghiemCanLamSang;
